import React, { useContext } from 'react';
import Modal from '../../../common/Modal';
import SubFilesByForm from './SubFilesByForm';
import { SubmissionContext } from '../../../../hooks/Contexts';

const FileCopyModal = ({
  showCopyFileModal,
  toggleCopyFileModal,
  field,
  responseID,
  handleFileCopy,
}) => {
  const { groupState } = useContext(SubmissionContext);
  const groupFormsSubsResponses = groupState.group_forms;
  /* subsByForm structure:
    [ 
      { 
        form: { name, id },
        linked_subs: [
          { submission: 
            { id, 
              responses: [ {
                field,
                response_files
              }]
            }
          }
        ]
      }
    ] */

  return (
    <Modal
      title='file-copy-modal'
      show={showCopyFileModal}
      onClose={toggleCopyFileModal}
    >
      <header>
        <h3>Select File to Copy into: {field.name}</h3>
      </header>

      <div className='creation-form'>
        {groupFormsSubsResponses.map((linkedForm) => (
          <SubFilesByForm
            key={`link-files-form-${linkedForm.id}`}
            linkedForm={linkedForm}
            responseID={responseID}
            handleFileCopy={handleFileCopy}
            toggleCopyFileModal={toggleCopyFileModal}
          />
        ))}
      </div>
    </Modal>
  );
};

export default FileCopyModal;
